var styles = {"icon":"PasswordStrength-module_icon__2I37f","invalid":"PasswordStrength-module_invalid__2eRIQ","valid":"PasswordStrength-module_valid__2zwAU","iconInvalid":"PasswordStrength-module_iconInvalid__1IiH8","text":"PasswordStrength-module_text__vregM"};

export { styles as default };
//# sourceMappingURL=PasswordStrength.module.css.js.map
